import { render, staticRenderFns } from "./the-sidebar-footer.vue?vue&type=template&id=0cd1adff"
import script from "./the-sidebar-footer.vue?vue&type=script&lang=ts"
export * from "./the-sidebar-footer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports